import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { NavLink } from 'react-router-dom';
import { currentDateAndTime, decodeData } from '../../Constants/constants';
class Shiftes extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);

        var days = [
            { day: 'Monday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Tuesday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Wednesday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Thursday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Friday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Saturday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } },
            { day: 'Sunday', start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } }
        ]
        this.state = {
            company_location_shift_id: 0,
            location_id: '',
            company_location_shift_code: '',
            company_location_shift_name: '',
            company_location_shift_in_time: '',
            company_location_shift_out_time: '',
            company_location_shift_duration: '',
            is_management_shift: '0',
            break_name: '',
            break_start_time: '',
            break_end_time: '',
            add_shift_rows: [],
            ot_max_hr_limit: 0,
            errors: {},
            days: days,
            loadingList: false,
            postLoading: false,
            infoLoading: false,
            info: [],
            decodedData: [],

        };
        this.closeRef = React.createRef();
    }
    componentDidMount() {
        if (this.props.params.company_location_shift_id) {
            this.setState({ loadingList: true, company_location_shift_id: this.props.params.company_location_shift_id }, (prevState) => {
                if (this.state.company_location_shift_id != 0) {
                    this.GetInfo();
                }
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    getBack=()=>{
        window.history.back();
    }

      handleRadioChange = (name,value) => {
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    }
    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
        let newState = { [name]: value };

        if (name === 'company_location_shift_name') {
            const code = value.split(' ').reduce((acc, word) => acc + word.charAt(0), '');
            newState['company_location_shift_code'] = code.toUpperCase();
        }

        this.setState(newState, () => {
            if (name === 'company_location_shift_in_time' || name === 'company_location_shift_out_time') {
                this.calculateDuration();
            }
        });
    };

    calculateDuration = () => {
        const { company_location_shift_in_time, company_location_shift_out_time } = this.state;
        if (company_location_shift_in_time && company_location_shift_out_time) {
            const inTime = new Date(`01/01/2000 ${company_location_shift_in_time}`);
            const outTime = new Date(`01/01/2000 ${company_location_shift_out_time}`);

            if (outTime < inTime) {
                outTime.setDate(outTime.getDate() + 1);
            }

            let durationInMilliseconds = outTime - inTime;

            let hours = Math.floor(durationInMilliseconds / (1000 * 60 * 60));
            let minutes = Math.floor((durationInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));

            let formattedHours = hours < 10 ? `0${hours}` : hours;
            let formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
            let durationString = `${formattedHours}.${formattedMinutes}`;

            this.setState({ company_location_shift_duration: durationString });
        }
    };

    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetShiftInfo?company_location_shift_id=${this.state.company_location_shift_id}`, { headers }).then((response) => {
            const { data, success, days } = response.data;
            if (success === true) {
                this.setState(
                    {
                        company_location_shift_code: data[0].company_location_shift_code,
                        company_location_shift_name: data[0].company_location_shift_name,
                        is_management_shift: data[0].is_management_shift,
                        infoLoading: false,
                        info: response.data,
                        add_shift_rows: response.data.breakresults,
                    }, (prevState) => {

                    }
                )
                var re_days = [];
                for (var d = 0; d < days.length; d++) {
                    var day = { day: days[d].shift_day, start_time: days[d].shift_start_time, start_time_grace_period: days[d].shift_start_time_grace_period, end_time: days[d].shift_end_time, end_time_grace_period: days[d].shift_end_time_grace_period, ot_max_hr_limit: days[d].ot_max_hr_limit, week_off: days[d].shift_week_off, week_off_weeks: { week_1: days[d].shift_weekoff_week_1, week_2: days[d].shift_weekoff_week_2, week_3: days[d].shift_weekoff_week_3, week_4: days[d].shift_weekoff_week_4, week_5: days[d].shift_weekoff_week_5 } };
                    re_days.push(day);
                }
                this.setState({
                    days: re_days
                })
            } else {
                this.setState({ infoLoading: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            if (errors.add_shift_rows) {
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: errors.add_shift_rows,
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            }
            this.setState({ errors });
            return;
        }

        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        const formData = {
            location_id: this.state.location_id,
            is_management_shift: this.state.is_management_shift,
            company_location_shift_id: this.state.company_location_shift_id,
            company_location_shift_code: this.state.company_location_shift_code,
            company_location_shift_name: this.state.company_location_shift_name,
            add_shift_rows: this.state.add_shift_rows,
            days: JSON.stringify(this.state.days),
            date: currentDateAndTime(),
        };

        if (this.state.company_location_shift_id !== 0) {
            formData.company_location_shift_id = this.state.company_location_shift_id;
        }

        axios.post(`${apiURL}Masters/CreateShift`, formData, { headers })
            .then((response) => {
                const { success, message } = response.data;
                if (success === true) {
                    this.resetForm();
                    this.resetFormBreak();
                    // Swal.fire({
                    //     title: `<strong>Success</strong>`,
                    //     text: message,
                    //     icon: 'success',
                    //     timer: 2000,
                    //     timerProgressBar: true,
                    //     showConfirmButton: false,
                    // });
                    // this.closeRef.current.click();
                     Swal.fire({
                     title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                     text: response.data.message,
                     icon: response.data.success === true ? 'success' : 'error',
                     showConfirmButton: true,
                     allowOutsideClick: false,
                                    })
                } else {
                     Swal.fire({
                                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                                        text: response.data.message,
                                        icon: response.data.success === true ? 'success' : 'error',
                                        showConfirmButton: true,
                                        allowOutsideClick: false,
                                    })
                                    this.setState({ postLoading:false,})
                    // Swal.fire({
                    //     title: `<strong>Failed</strong>`,
                    //     text: message,
                    //     icon: 'error',
                    //     timer: 2000,
                    //     timerProgressBar: true,
                    //     showConfirmButton: false,
                    // });
                }

            })
            .catch((error) => {
                this.setState({ postLoading:false })

                // console.error('API call error:', error);
                // Swal.fire({
                //     title: `<strong>Failed</strong>`,
                //     text: 'An error occurred while processing your request.',
                //     icon: 'error',
                //     timer: 2000,
                //     timerProgressBar: true,
                //     showConfirmButton: false,
                // });
            });
    };


    resetForm = () => {
        this.setState({
            company_location_shift_id: 0,
            location_id: '',
            company_location_shift_code: '',
            company_location_shift_name: '',
            company_location_shift_in_time: '',
            company_location_shift_out_time: '',
            company_location_shift_duration: '',
            ot_max_hr_limit: 0,
            days: this.state.days.map(day => ({ ...day, start_time: '12:00:00', start_time_grace_period: '00', end_time: '12:00:00', end_time_grace_period: '00', ot_max_hr_limit: 0, week_off: 0, week_off_weeks: { week_1: 0, week_2: 0, week_3: 0, week_4: 0, week_5: 0 } })),
        });
    };
    resetFormBreak = () => {
        this.setState({
            break_name: '',
            break_start_time: '',
            break_end_time: '',
        });

    }

    validateForm = () => {
        const errors = {};

        if (!this.state.company_location_shift_name) {
            errors.company_location_shift_name = 'Shift name is required';
        }
        if (!this.state.company_location_shift_code) {
            errors.company_location_shift_code = 'Shift code is required';
        }
        // if (this.state.add_shift_rows.length === 0) {
        //     errors.add_shift_rows = 'The Break is required';
        // } 

        return errors;
    };

    validateFormBreak = () => {
        const errors = {};

        if (!this.state.break_name) {
            errors.break_name = 'Break name is required';
        }
        if (!this.state.break_start_time) {
            errors.break_start_time = 'Break start time is required';
        }
        if (!this.state.break_end_time) {
            errors.break_end_time = 'Break end time is required';
        }

        return errors;
    };

    handleAddRows = () => {
        const errors = this.validateFormBreak();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { break_name, break_start_time, break_end_time, add_shift_rows } = this.state;

        if (break_name && break_start_time) {
            const newAllowance = {
                break_name: break_name,
                break_start_time: break_start_time,
                break_end_time: break_end_time,
            };

            this.setState({
                add_shift_rows: [...add_shift_rows, newAllowance],
            });
            this.resetFormBreak();
        }
    };

    handleDeleteRow = (index) => {
        const { add_shift_rows } = this.state;
        const updatedadd_shift_rows = add_shift_rows.filter((_, i) => i !== index);
        this.setState({ add_shift_rows: updatedadd_shift_rows });
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    company_location_shift_id: id,
                    date: currentDateAndTime(),

                };
                axios
                    .post(`${apiURL}Masters/DeleteShift`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handleStartTime = (e, index) => {
        this.state.days[index].start_time = e.target.value;
        this.setState({ days: this.state.days }, () => { });
    }
    handleStartGraceTime = (e, index) => {
        this.state.days[index].start_time_grace_period = e.target.value;
        this.setState({ days: this.state.days }, () => { });
    }
    handleEndTime = (e, index) => {
        this.state.days[index].end_time = e.target.value;
        this.setState({ days: this.state.days }, () => { });
    }
    handleEndGraceTime = (e, index) => {
        this.state.days[index].end_time_grace_period = e.target.value;
        this.setState({ days: this.state.days }, () => { });
    }
    handleMaxOThrs = (e, index) => {
        this.state.days[index].ot_max_hr_limit = e.target.value;
        this.setState({ days: this.state.days }, () => { });
    }


    handleWeekOff = (e, index) => {
        this.state.days[index].week_off = e.target.checked ? 1 : 0;
        this.setState({ days: this.state.days }, () => { });
    }
    handleWeekOffWeeks = (e, index, week) => {
        if (week === 1) {
            this.state.days[index].week_off_weeks.week_1 = e.target.checked ? 1 : 0;
        } else if (week === 2) {
            this.state.days[index].week_off_weeks.week_2 = e.target.checked ? 1 : 0;
        } else if (week === 3) {
            this.state.days[index].week_off_weeks.week_3 = e.target.checked ? 1 : 0;
        } else if (week === 4) {
            this.state.days[index].week_off_weeks.week_4 = e.target.checked ? 1 : 0;
        } else if (week === 5) {
            this.state.days[index].week_off_weeks.week_5 = e.target.checked ? 1 : 0;
        }
        this.setState({ days: this.state.days });
    }
    convertTo12HourFormat(time24) {
        const [hours, minutes] = time24.split(':');
        let period = 'AM';
        let hours12 = parseInt(hours, 10);

        if (hours12 >= 12) {
            period = 'PM';
            if (hours12 > 12) {
                hours12 -= 12;
            }
        }

        return `${hours12}:${minutes} ${period}`;
    }
    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Shifts Master`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Shifts Scheduler</h4>
                                        <button className="btn btn-success btn-sm" 
                                        // to={"/ShifteList"}
                                        onClick={()=> this.getBack()}
                                        >
                                            <i className="bx bx-list-ul label-icon align-middle fs-4 " />
                                        </button>
                                        <button 
                                        // to={"/ShifteList"} 
                                        onClick={()=> this.getBack()}
                                        ref={this.closeRef} type="button" style={{ display: "none" }}>
                                        </button>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={this.handleSubmit} className="row">
                                                    <div className="col-md-8 mt-3">
                                                        <label htmlFor="company_location_shift_name" className="form-label">Shift Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.company_location_shift_name ? 'is-invalid' : ''}`}
                                                            id="company_location_shift_name"
                                                            name="company_location_shift_name"
                                                            value={this.state.company_location_shift_name}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Shift Name"
                                                        />
                                                        {errors.company_location_shift_name && <div className="text-danger">{errors.company_location_shift_name}</div>}
                                                    </div>
                                                    <div className="col-md-4 mt-3">
                                                        <label htmlFor="company_location_shift_code" className="form-label">Shift code</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.company_location_shift_code ? 'is-invalid' : ''}`}
                                                            id="company_location_shift_code"
                                                            name="company_location_shift_code"
                                                            value={this.state.company_location_shift_code}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Shift code"
                                                        />
                                                        {errors.company_location_shift_code && <div className="text-danger">{errors.company_location_shift_code}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <table className='table table-bordered table-stripped text-center'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Week Off</th>
                                                                    <th>Day</th>
                                                                    <th>Start Time</th>
                                                                    {/* <th>Grace Time</th> */}
                                                                    <th>End Time</th>
                                                                    {/* <th>Grace Time</th> */}
                                                                    {/* <th>MAX OT HRs</th> */}
                                                                </tr>
                                                            </thead>

                                                            {
                                                                this.state.days.map((day, index) => {
                                                                    return <tbody>
                                                                        {

                                                                            day.week_off === 1 ? <tr className='table-warning'><td width={`3%`}><input type='checkbox' checked onChange={(e) => { this.handleWeekOff(e, index) }} value={day.week_off} /></td><td colSpan={5}><b>{day.day}</b></td></tr> :

                                                                                <tr key={`days-${index}`}>
                                                                                    <td width={`3%`}><input type='checkbox' onChange={(e) => { this.handleWeekOff(e, index) }} value={day.week_off} /></td>
                                                                                    <td style={{ verticalAlign: 'middle' }} width={`8%`}><b>{day.day}</b></td>
                                                                                    <td style={{ verticalAlign: 'middle' }} width={`8%`}><TextBox type='time' id='company_location_shift_in_time' name='company_location_shift_in_time' change={(e) => this.handleStartTime(e, index)} value={this.state.days[index].start_time} /></td>
                                                                                    {/* <td width={`15%`}> <TextBox type='number' value={this.state.days[index].start_time_grace_period} hint='Grace Period' change={(e) => this.handleStartGraceTime(e, index)} /></td> */}
                                                                                    <td width={`10%`}><TextBox type='time' id='company_location_shift_out_time' name='company_location_shift_out_time' change={(e) => this.handleEndTime(e, index)} value={this.state.days[index].end_time} /></td>
                                                                                    {/* <td width={`15%`}> <TextBox type='number' value={this.state.days[index].end_time_grace_period} hint='Grace Period' change={(e) => this.handleEndGraceTime(e, index)} /></td> */}
                                                                                    {/* <td width={`15%`}> <TextBox type='number' value={this.state.days[index].ot_max_hr_limit} hint='MAX OT' change={(e) => this.handleMaxOThrs(e, index)} /></td> */}
                                                                                </tr>
                                                                        }
                                                                        {
                                                                            day.week_off === 1 ?

                                                                                <tr>
                                                                                    <td colSpan={10}>
                                                                                        <div className='row'>
                                                                                            <div className='col-md-2'>
                                                                                                <input className="form-check-input" type="checkbox" onChange={(e) => { this.handleWeekOffWeeks(e, index, 1) }} checked={day.week_off_weeks.week_1 === 1 ? true : false} value={day.week_off_weeks.week_1} id={`week_of_day${index}_1`} />
                                                                                                <label className="form-check-label" htmlFor={`week_of_day${index}_1`} style={{ marginLeft: '10px' }}>  Week 1 </label>
                                                                                            </div>
                                                                                            <div className='col-md-2'>
                                                                                                <input className="form-check-input" type="checkbox" onChange={(e) => { this.handleWeekOffWeeks(e, index, 2) }} checked={day.week_off_weeks.week_2 === 1 ? true : false} value={day.week_off_weeks.week_2} id={`week_of_day${index}_2`} />
                                                                                                <label className="form-check-label" htmlFor={`week_of_day${index}_2`} style={{ marginLeft: '10px' }}>  Week 2 </label>
                                                                                            </div>
                                                                                            <div className='col-md-2'>
                                                                                                <input className="form-check-input" type="checkbox" onChange={(e) => { this.handleWeekOffWeeks(e, index, 3) }} checked={day.week_off_weeks.week_3 === 1 ? true : false} value={day.week_off_weeks.week_3} id={`week_of_day${index}_3`} />
                                                                                                <label className="form-check-label" htmlFor={`week_of_day${index}_3`} style={{ marginLeft: '10px' }}>  Week 3 </label>
                                                                                            </div>
                                                                                            <div className='col-md-2'>
                                                                                                <input className="form-check-input" type="checkbox" onChange={(e) => { this.handleWeekOffWeeks(e, index, 4) }} checked={day.week_off_weeks.week_4 === 1 ? true : false} value={day.week_off_weeks.week_4} id={`week_of_day${index}_4`} />
                                                                                                <label className="form-check-label" htmlFor={`week_of_day${index}_4`} style={{ marginLeft: '10px' }}>  Week 4 </label>
                                                                                            </div>
                                                                                            <div className='col-md-2'>
                                                                                                <input className="form-check-input" type="checkbox" onChange={(e) => { this.handleWeekOffWeeks(e, index, 5) }} checked={day.week_off_weeks.week_5 === 1 ? true : false} value={day.week_off_weeks.week_5} id={`week_of_day${index}_5`} />
                                                                                                <label className="form-check-label" htmlFor={`week_of_day${index}_5`} style={{ marginLeft: '10px' }}>  Week 5 </label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>

                                                                                </tr> :
                                                                                <div></div>
                                                                        }
                                                                    </tbody>
                                                                })
                                                            }
                                                        </table>
                                                    </div>

                                                    <div className='row px-5 mt-3'>
                                                        <div className="form-check col-md-12 mb-3 ">
                                                            <input
                                                                type="checkbox"
                                                                id="is_management_shift"
                                                                name="is_management_shift"
                                                                value="1"
                                                                checked={this.state.is_management_shift === "1"}
                                                                onChange={(e) =>
                                                                    this.handleRadioChange(
                                                                        "is_management_shift",
                                                                        e.target.checked ? "1" : "0"
                                                                    )
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor="is_management_shift">
                                                                Is this management shift
                                                            </label>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <label htmlFor="break_name" className="form-label">Break Name</label>
                                                            <input
                                                                type="text"
                                                                className={`form-control ${errors.break_name ? 'is-invalid' : ''}`}
                                                                id="break_name"
                                                                name="break_name"
                                                                value={this.state.break_name}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Enter Break Name"
                                                            />
                                                            {errors.break_name && <div className="text-danger">{errors.break_name}</div>}
                                                        </div>
                                                        <div className="col-md-3">
                                                            <label htmlFor="break_start_time" className="form-label">Break start time</label>
                                                            <input
                                                                type="time"
                                                                className={`form-control ${errors.break_start_time ? 'is-invalid' : ''}`}
                                                                id="break_start_time"
                                                                name="break_start_time"
                                                                value={this.state.break_start_time}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Enter Break time"
                                                            />
                                                            {errors.break_start_time && <div className="text-danger">{errors.break_start_time}</div>}
                                                        </div>
                                                        <div className="col-md-3">
                                                            <label htmlFor="break_end_time" className="form-label">Break end time</label>
                                                            <input
                                                                type="time"
                                                                className={`form-control ${errors.break_end_time ? 'is-invalid' : ''}`}
                                                                id="break_end_time"
                                                                name="break_end_time"
                                                                value={this.state.break_end_time}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Enter Break time"
                                                            />
                                                            {errors.break_end_time && <div className="text-danger">{errors.break_end_time}</div>}
                                                        </div>
                                                        <div className="col-md-3" style={{ marginTop: "30px" }}>
                                                            <button
                                                                type="button"
                                                                className="btn btn-success btn-label waves-effect right waves-light"
                                                                onClick={this.handleAddRows}>
                                                                <i className="bx bx-add-to-queue label-icon align-middle fs-16 ms-2" />{" "}
                                                                Add
                                                            </button>
                                                        </div>
                                                        <table className={`table table-bordered table-hover mt-5`}>
                                                            <thead className='table-light'>
                                                                <tr>
                                                                    <th width={200}>Break name</th>
                                                                    <th width={200}>Break start time</th>
                                                                    <th width={200}>Break end time</th>
                                                                    <th width={120}>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    this.state.add_shift_rows.map((row, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td>{row.break_name}</td>
                                                                                <td>{this.convertTo12HourFormat(row.break_start_time)}</td>
                                                                                <td>{this.convertTo12HourFormat(row.break_end_time)}</td>
                                                                                <td className='d-flex justify-content-around'>
                                                                                    <button
                                                                                        onClick={() => this.handleDeleteRow(index)}
                                                                                        className="btn-icon btn btn-sm btn-outline-danger">
                                                                                        <i className="ri-delete-bin-line"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div className="col-md-12 mt-5">
                                                        {
                                                            this.state.company_location_shift_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />

                                                        }

                                                        {
                                                            this.state.company_location_shift_id !== 0 ? <NavLink style={{ float: 'right' }} type="button" to={'/ShifteList'} className={`btn btn-light right btn-label`} onClick={this.resetForm} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />New</NavLink> : <div></div>

                                                        }
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(Shiftes);